import { configureStore } from "@reduxjs/toolkit"
import authReducer from "../../features/auth/authSlice"
import sidebarReducer from "../../features/sidebar/sidebarSlice"
import themeReducer from "../../features/theme/themeSlice"
import filtersReducer from "../../features/filters/filterSlice"
import jobsReducer from "../../features/jobs/jobSlice"
import companyMembersReducer from "../../features/companyMembers/companyMemberSlice"
import companiesReducer from "../../features/companies/companySlice"

export const store = configureStore({
  reducer: {
    auth: authReducer,
    theme: themeReducer,
    sidebar: sidebarReducer,
    filters: filtersReducer,
    jobs: jobsReducer,
    companyMembers: companyMembersReducer,
    companies: companiesReducer,
  },
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
